module.exports = __webpack_public_path__ + "assets/DINPro-Medium-2e7ded00.otf";